import React, { useState } from 'react';
import './OrgLogin.scss';
import logo from '../../../assets/OHM_1.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { onOrgLogin } from '../../../Redux/OrganizationSlice';
import { api } from '../../../Api-Endpoints/apiEndpoint';

function OrgLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isOrgAuth } = useSelector(state => state.Organization);
  const [input, setInput] = useState({
    email: '',
    password: '',
  });

  const handleForgotPasswordClick = () => {
    navigate('/reset-password');
  };

  const handleLoginClick = async () => {
    try {
      const { status, data } = await api.post('/org/org-login', input);
      if (status == 200 && data.success) {
        dispatch(onOrgLogin(data.org));
        // navigate("/dashboard");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const onChangeInput = e => {
    const { name, value } = e.target;
    setInput(prev => ({ ...prev, [name]: value }));
  };
  if (isOrgAuth) {
    navigate('/org-dashboard');
  }

  return (
    <>
      <div className="loginSignUp">
        <div className="main">
          <div className="left">
            <div className="image">
              <img src={logo} alt="logo" />
            </div>
            <div className="heading-sighin">
              <p>Sigh In </p>
              <span className="ml-1">Organization</span>
            </div>
            <div className="input-feild">
              <input
                type="text"
                name={'email'}
                value={input.email}
                onChange={onChangeInput}
                placeholder="E-mail"
              />
              <input
                type="password"
                name={'password'}
                value={input.password}
                onChange={onChangeInput}
                placeholder="Password"
              />
            </div>
            <div className="buttens">
              <button className="login-btn" onClick={handleLoginClick}>
                Login
              </button>
              <button className="fp-btn" onClick={handleForgotPasswordClick}>
                Forgot Password?
              </button>
            </div>
          </div>
          <div className="right">
            <div className="head-text-combine">
              <div className="heading-welcome">
                <p>Welcome to Ohm-Hub!</p>
              </div>
              <div className="text-for-welcome">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Earum eum sed animi consectetur mollitia nesciunt modi cum
                  quibusdam molestias. <br />
                  <br />
                  Lorem ipsum dolor sit amet consectetur adipisicing elit
                  oluptates!
                </p>
              </div>
              <div className="button-for-welcome">
                <button className="Privacy">Privacy Policy</button>
                <button className="terms">Terms & Condition</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrgLogin;
